// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"7567beb6","208":"e20c528f","209":"bf24443b","787":"f90c8bef","878":"7b1fdd87"}[chunkId] + ".chunk.js";
};